import * as atatus from 'atatus-spa';

export function configAtatus() {
  atatus.config('3a1ef7d1b50b461da74017f594d6ef01').install();
}
